/**
 * Admin Team Management Route
 * Requires admin role to access
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { TeamManagement } from '../../pages/Admin/TeamManagement';

export const Route = createFileRoute('/_authenticated/admin/team')({
  beforeLoad: ({ context }) => {
    // Check if user is admin
    const user = (context as any)?.user;
    if (user && user.role !== 'admin') {
      throw redirect({
        to: '/home',
      });
    }
  },
  component: TeamManagement,
});
